import { isObject } from '@utils/types'
import { Dropdown as DD } from 'primereact/dropdown'
import { createElement } from 'react'

/**
 * Thin wrapper around PrimeReact's Dropdown that defaults `showClear` to true, forces a fixed
 * panel z-index, and resolves `value` to `props.value[props.optionValue]` when an object is
 * passed instead of a scalar option value.
 *
 * @component
 * @param {Object} props - Props forwarded to PrimeReact's Dropdown (value, optionValue, showClear, ...).
 * @returns {React.JSX.Element}
 */
export default function Dropdown(props) {
  const options = {
    ...props,
    showClear: props.showClear ?? true,
    pt: {
      panel: {
        style: { zIndex: 1200 }
      }
    },
    value: isObject(props.value) && props.optionValue ? props.value[props.optionValue] : props.value
  }

  return createElement(DD, options)
}

Dropdown.displayName = 'Dropdown'
